import { usePostMutation } from "../../../hooks/useClientPortalQuery";

import { ConfirmPaymentResponse, CreateSCAModel } from "../../../types/generated/models";
import { useClientPortalConfigContext } from "../../../context/ClientPortalConfig.ctx";
import { AxiosError } from "axios";
import { RecaptchaAction } from "utils/recaptcha";

export function useCreateSCAIntent(clientId?: number) {
    const { clientPortalGuid } = useClientPortalConfigContext();
    const isInvoiceLinkPayment = !!clientId;
    const { mutateAsync } = usePostMutation<ConfirmPaymentResponse, AxiosError, CreateSCAModel>({
        url: `/api/v1/${clientPortalGuid}/Stripe/${isInvoiceLinkPayment ? "InvoicePayCreateSCAIntent" : "CreateSCAIntent"}`,
        recaptchaAction: isInvoiceLinkPayment ? RecaptchaAction.InvoicePayment : RecaptchaAction.Payment,
    });

    return {
        createSCAIntent: mutateAsync,
    };
}
